<template>
  <b-tabs 
    v-model="tab"
    v-bind="remapOptions"
    :nav-class="`mc-tab-nav ${type}`"
    active-nav-item-class="mc-tab-active-item"
    :content-class="`mc-tab-content ${contentClass}`"
    active-tab-class="mc-tab-active-body"
  >
    <slot :items="items">
      <b-tab 
        v-for="(val, key) in items"
        :title="val.title"
        :active="val.active"
        :key="key"
        :disabled="val?.attributes?.disabled"
      >
        <p>{{ val.content }}</p>
      </b-tab>
    </slot>
  </b-tabs>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultType: ['tabs', 'pills']
    }
  },
  computed: {
    type() {
      const type = this.options?.type
      return type && !this.defaultType.includes(type) ? `nav-${type}` : ''
    },
    remapOptions() {
      const type = this.options?.type
      if (type && type == 'pills') {
        return {...this.options, ...{ pills: true }}
      }
      return this.options
    },
    contentClass() {
      if (Object.hasOwn(this.options, 'content-class')) {
        return this.options['content-class']
      }
      return ''
    },
    tab: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      }
    }
  }
}
</script>
<style lang="scss">
  // CUSTOM PILLS
  .mc-tab-nav.nav-pills .nav-link:not(.active) {
    border: 1px solid transparent !important;
  }
  .mc-tab-nav.nav-pills .nav-link.active {
    background: $gray !important;
    color: $blue !important;
    border: 1px solid $blue !important;
  }
  .mc-tab-nav.nav-pills .nav-link:not(.active):hover,
  .mc-tab-nav.nav-tabs .nav-link:not(.active):hover,
  .mc-tab-nav.nav-flats .nav-link.active,
  .mc-tab-nav.nav-flats .nav-link:not(.active):hover {
    color: $blue;
  }
  .mc-tab-nav .nav-link.disabled {
    color: $teal-200 !important;
  }

  // CUSTOM TABS DEFAULT
  .mc-tab-nav.nav-tabs .nav-link.active {
    border-color: $teal-200;
  }
  .mc-tab-nav.nav-tabs .nav-link:not(.active):hover {
    border: 1px solid $teal-100;
  }
  .mc-tab-nav.nav-tabs .nav-link:not(.active) {
    border-bottom: 1px solid $teal-200;
  }

  // FLATS TABS
  .mc-tab-nav.nav-flats .nav-link {
    border-color: transparent !important;
  }
  .mc-tab-nav.nav-flats .nav-link.active {
    border-bottom: 1px solid $blue !important;
  }
  .mc-tab-nav.nav-flats .nav-link:not(.active):hover,
  .mc-tab-nav.nav-flats .nav-link:not(.active),
  .mc-tab-nav.nav-tabs .nav-link:not(.active):hover {
    border-bottom: 1px solid $teal-200 !important;
  }
</style>